import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function localizedSlug(item, lang) {
  if (!item) return "";
  const s = lang === "ro" ? item.slug_ro : item.slug_en;
  return s || item.slug || "";
}

const SITE_URL = "https://oanamudura.com";

function upsertMeta(attr, key, value) {
  if (value == null || value === "") return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function upsertLink(rel, href, hreflang) {
  const sel = hreflang
    ? `link[rel="alternate"][hreflang="${hreflang}"]`
    : `link[rel="${rel}"]:not([hreflang])`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Bilingual SEO head manager: title, meta description, canonical, hreflang (en/ro/x-default), Open Graph & Twitter.
export function applySeo({ title, description, path = "/", enPath, roPath }) {
  const url = SITE_URL + path;
  if (title) {
    document.title = title;
    upsertMeta("property", "og:title", title);
    upsertMeta("name", "twitter:title", title);
  }
  if (description) {
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:description", description);
    upsertMeta("name", "twitter:description", description);
  }
  upsertMeta("property", "og:url", url);
  upsertLink("canonical", url);
  upsertLink("alternate", SITE_URL + (enPath || path), "en");
  upsertLink("alternate", SITE_URL + (roPath || path), "ro");
  upsertLink("alternate", SITE_URL + (enPath || path), "x-default");
}
